/**
 * Shop Follow Service
 * Handles shop follow/unfollow functionality
 */

import { followerRepository } from '../../data/followerRepository';
import { Shop } from '../types/shop';
import { logger } from '../../infrastructure/logger';

export const shopFollowService = {
    /**
     * Follow a shop
     */
    async followShop(shopId: string, userId: string): Promise<void> {
        try {
            await followerRepository.followShop(shopId, userId);
        } catch (error) {
            logger.error('[ShopFollowService] Error following shop', error);
            throw error;
        }
    },

    /**
     * Unfollow a shop
     */
    async unfollowShop(shopId: string, userId: string): Promise<void> {
        try {
            await followerRepository.unfollowShop(shopId, userId);
        } catch (error) {
            logger.error('[ShopFollowService] Error unfollowing shop', error);
            throw error;
        }
    },

    /**
     * Check if user follows shop
     */
    async isFollowingShop(shopId: string, userId: string): Promise<boolean> {
        try {
            return await followerRepository.isFollowingShop(shopId, userId);
        } catch (error) {
            logger.error('[ShopFollowService] Error checking follow status', error);
            return false;
        }
    },

    /**
     * Get shops followed by user
     */
    async getShopsFollowingByUser(userId: string): Promise<Shop[]> {
        try {
            return await followerRepository.getShopsFollowingByUser(userId);
        } catch (error) {
            logger.error('[ShopFollowService] Error getting followed shops', error);
            return [];
        }
    },

    /**
     * Get following shop IDs
     */
    async getFollowingShopIds(userId: string): Promise<string[]> {
        try {
            return await followerRepository.getFollowingShopIds(userId);
        } catch (error) {
            logger.error('[ShopFollowService] Error getting following shop IDs', error);
            return [];
        }
    }
};
